import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { composeErrorMessage } from "../../utils/utils";
import eventTicketsService from "./eventTicketsService";

const initialState = {
  tickets: [],
  gettingTickets: false,
  errorGettingTickets: "",
  activatingTicket: false,
  activatingTicketError: "",
};

export const getGuestTickets = createAsyncThunk(
  "eventTickets/getGuestTickets",
  async ({ eventId, guestId }, thunkAPI) => {
    try {
      return await eventTicketsService.getGuestTickets({ eventId, guestId });
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  },
);

export const activateWearableTicket = createAsyncThunk(
  "eventTickets/activateWearableTicket",
  async ({ eventId, serialNumber, ticketId }, thunkAPI) => {
    try {
      return await eventTicketsService.activateWearableTicket({
        eventId,
        serialNumber,
        ticketId,
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  },
);

export const eventTicketsSlice = createSlice({
  name: "eventTickets",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGuestTickets.pending, (state) => {
        state.gettingTickets = true;
        state.errorGettingTickets = "";
      })
      .addCase(getGuestTickets.fulfilled, (state, action) => {
        state.gettingTickets = false;
        state.tickets = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getGuestTickets.rejected, (state, action) => {
        state.gettingTickets = false;
        state.errorGettingTickets = action.payload;
      })
      .addCase(activateWearableTicket.pending, (state) => {
        state.activatingTicket = true;
        state.activatingTicketError = "";
      })
      .addCase(activateWearableTicket.fulfilled, (state, action) => {
        state.activatingTicket = false;
        const updatedTicket = action.payload;
        if (!updatedTicket?.id) {
          return;
        }

        const index = state.tickets.findIndex(
          (ticket) => ticket.id === updatedTicket.id,
        );
        if (index >= 0) {
          state.tickets[index] = updatedTicket;
        } else {
          state.tickets.push(updatedTicket);
        }
      })
      .addCase(activateWearableTicket.rejected, (state, action) => {
        state.activatingTicket = false;
        state.activatingTicketError = action.payload;
      });
  },
});

export const { reset } = eventTicketsSlice.actions;
export default eventTicketsSlice.reducer;
